import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { VehicleService } from '../vehicle/vehicle.service';
import { Vehicle } from '../vehicle/vehicle';

@Injectable({ providedIn: 'root'})
export class VehicleResolver implements Resolve<Observable<Vehicle[]>>{

    constructor(private service: VehicleService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Vehicle[]> {
        return this.service.findAll();
    }
}